module.exports = __webpack_public_path__ + "../static/img/refresh.5370c139.png";